import { PARTNER_URL } from '@/api/partner'
import { vuexHandbook } from '@/store/composition/module/handbook'

const state = () => ({
  partnerList: [],
  generalContractor: []
})

const getters = {
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions(),
  async GETPartnerList ({ dispatch }, { search = null, searchkey = 'ForContract' } = {}) {
    await dispatch('GETRequest', {
      url: PARTNER_URL,
      keyStateList: 'partnerList',
      errorMsg: 'Не удалось загрузить список контрагентов',
      search,
      searchkey
    })
  },
  async GETGeneralContractor ({ dispatch }, { search = 'true', searchkey = 'pto_default' } = {}) {
    await dispatch('GETRequest', {
      url: PARTNER_URL,
      keyStateList: 'generalContractor',
      errorMsg: 'Не удалось загрузить субподрядчика по умолчанию',
      search,
      searchkey
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
